import React from 'react'
import { Checkbox, FormGroup, FormControlLabel } from '@material-ui/core'
import classes from './Form.module.sass'

export default function CheckboxInput({ register, name, label, ...rest }) {
  return (
    <FormGroup>
      <FormControlLabel control={(
        <Checkbox
          InputLabelProps={{ classes: { shrink: classes.shrink } }}
          {...register(name)}
          {...rest}
        />
      )} label={label} />

    </FormGroup>

  )
}
